import Api from '@/api'

// Shared by the product creation flow (ProductCreation.vue) and the product
// details "page after scan" tab (ProductDetailsRedirection.vue) so both write
// the same destination shape.

export function buildDestinationPayload ({ destinationType, url, stcConfig, customPageId }) {
  if (destinationType === 'redirect') {
    return { type: 'url', url: url, stc_config: null }
  }
  if (destinationType === 'dpp') {
    return { type: 'dpp', url: Api.dpp_landing_page_url, stc_config: null }
  }
  return {
    type: 'stc',
    url: Api.default_stc_url,
    stc_config: destinationType === 'existing' ? stcConfig : customPageId
  }
}

// `t` is the caller's $t, so validation copy stays in the consuming component's locale context.
export function urlRules (t) {
  return [
    v => !v || /^(?:https?|ftp):\/\//i.test(v) || t('url_validation_scheme'),
    v => (!v || /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(v)) || t('url_validation'),
    v => (v || '').length <= 300 || t('field_characters_limit', { count: 300 }),
    v => !!v || t('field_required')
  ]
}
